import { C } from "@/brand/tokens";
import { proofBand5 } from "@/brand/content";

/**
 * ProofBandSection5 — Dry Stone compact proof band.
 *
 * Sits immediately below the hero. Four verifiable trust signals
 * arranged as a horizontal row so the right buyer registers seriousness
 * before scrolling past the fold.
 *
 * No decorative chrome — a single brass hairline top rail, brass
 * ordinals, tight editorial spacing.
 */
export function ProofBandSection5() {
  return (
    <section
      data-testid="proof-band"
      style={{
        background: C.surfaceLight,
        color: C.textOnLight,
        borderTop: `1px solid ${C.brassSoft}`,
        borderBottom: `1px solid ${C.brassSoft}`,
      }}
    >
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-12 py-12 lg:py-14">
        <div className="flex flex-col lg:flex-row lg:items-baseline gap-8 lg:gap-6">
          <div className="lg:w-[220px] shrink-0">
            <div className="flex items-center gap-3">
              <span
                aria-hidden="true"
                className="inline-block h-px w-10"
                style={{ background: C.accentMetal }}
              />
              <p
                className="font-inter text-[10.5px] uppercase font-semibold"
                style={{
                  color: C.accentMetal,
                  letterSpacing: "0.28em",
                }}
              >
                The practice
              </p>
            </div>
            <p
              className="mt-4 font-cormorant italic"
              style={{
                color: C.inkOnLight,
                fontSize: "1.05rem",
                lineHeight: 1.35,
              }}
            >
              Signals of fit, not marketing claims.
            </p>
          </div>

          <ul
            className="flex-1 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8"
            data-testid="proof-band-list"
          >
            {proofBand5.map((p, i) => (
              <li
                key={p.label}
                data-testid={`proof-band-item-${i}`}
                className="flex items-baseline gap-3"
              >
                <span
                  className="font-inter text-[10px] uppercase font-bold tabular-nums shrink-0"
                  style={{
                    color: C.accentMetal,
                    letterSpacing: "0.28em",
                  }}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <p
                    className="font-inter text-[12px] uppercase font-semibold mb-1.5"
                    style={{
                      color: C.accentFunctional,
                      letterSpacing: "0.16em",
                    }}
                  >
                    {p.label}
                  </p>
                  <p
                    className="font-inter text-[13.5px] leading-[1.55]"
                    style={{
                      color: C.inkOnLight,
                    }}
                  >
                    {p.body}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
